import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-sans/800.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import '@fontsource/geist-mono/600.css';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ConfirmProvider } from './components/ConfirmProvider';

// BrowserRouter (URL veri, non hash): ogni sezione ha il suo indirizzo, quindi
// e' condivisibile, ricaricabile e raggiungibile col tasto "indietro". Regge
// anche in produzione perche' il server rimanda su index.html i percorsi che non
// sono API (catch-all SPA in server/index.js).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  </React.StrictMode>
);
